const SVG = ({ fill = 'none', width = '44', height = '44', viewBox = '0 0 44 44' }) => (
  <svg width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <path d="M0 44H44V0H0V44Z" fill="#FF0000"/>
      <path d="M21.9993 4.58105C28.2377 4.58105 34.9043 15.7342 34.9043 25.3926C34.9043 32.979 30.4447 39.4508 21.9993 39.4508C13.5476 39.4508 9.09961 32.979 9.09961 25.3926C9.09961 15.7342 15.7599 4.58105 21.9993 4.58105Z" fill="white"/>
  </svg>
)

export default SVG
